<ng-container *ngIf="isIconBadge; else text">
  <img class="badge-image" [src]="badgeIconUrl" [alt]="badge" />
</ng-container>
<ng-template #text>
  <span class="badge-text">{{ badge }}</span>
</ng-template>
